(() => {
  const initSection = (root = document) => {
    root.querySelectorAll('[data-nishe-tabs]').forEach((section) => {
      if (section.dataset.tabsReady === 'true') return;
      section.dataset.tabsReady = 'true';
      const buttons = [...section.querySelectorAll('[data-tab-button]')];
      const panels = [...section.querySelectorAll('[data-tab-panel]')];

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const id = button.dataset.tabButton;
          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach((panel) => {
            const active = panel.dataset.tabPanel === id;
            panel.hidden = !active;
            panel.classList.toggle('is-active', active);
          });
          button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      });
    });

    root.querySelectorAll('[data-scroll-control]').forEach((button) => {
      if (button.dataset.scrollReady === 'true') return;
      button.dataset.scrollReady = 'true';
      button.addEventListener('click', () => {
        const wrapper = button.closest('[data-carousel]');
        const track = wrapper?.querySelector('[data-carousel-track]');
        if (!track) return;
        const direction = button.dataset.scrollControl === 'next' ? 1 : -1;
        track.scrollBy({ left: direction * track.clientWidth * .82, behavior: 'smooth' });
      });
    });
  };

  const initReveals = (root = document) => {
    const items = [...root.querySelectorAll('.nishe-reveal:not(.is-visible)')];
    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          instance.unobserve(entry.target);
        }
      });
    }, { threshold: .08, rootMargin: '0px 0px -40px' });
    items.forEach((item) => observer.observe(item));
  };

  document.addEventListener('DOMContentLoaded', () => {
    initSection();
    initReveals();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initSection(event.target);
    initReveals(event.target);
  });
})();
